import React from 'react';
import { WrenchIcon } from 'lucide-react';
import { getCheckoutHref } from '../utils/commerce';
export function CtaButton({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <a href={getCheckoutHref()} className={`inline-flex w-full max-w-[300px] items-center justify-center gap-1.5 rounded-[4px] bg-gold px-4 py-2.5 font-display text-[13px] uppercase tracking-[0.03em] text-navy shadow-[0_2px_0_#B38900] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-[#FFD23F] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold active:translate-y-[2px] active:shadow-none ${className}`} data-id="element-2" data-mp="hkx7oeb6ih9p">
      <WrenchIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-3" data-mp="vclime9oyzp3" />
      <span className="whitespace-nowrap" data-id="element-4" data-mp="19aa15fgaduqz">{children}</span>
    </a>;
}